import React, { useState, Fragment, Component } from 'react'
import Shimmer from "react-shimmer-effect";
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button
} from "reactstrap"
import { Link, useHistory, useParams } from "react-router-dom"
import { withRouter } from "react-router";

import apiResponse from '../../../../services/apiResponse'

import FormBloc from './Blocs/FormBloc'
import moment from 'moment';
import { ConfirmAlert } from '../../../../helpers/ui/alert'

class IndexView extends Component {

    formBloc = new FormBloc()

    constructor(props) {
        super(props)
        this.state = {
            loading: false
        }
    }

    handleButtonPrint = () => {
        this.formBloc.fetchPdf({uuid: this.state.detail.ip_uuid})
    }

    componentDidMount() {
        this.formBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response.main
                        this.setState({
                            detail: response
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        const queryParams = new URLSearchParams(this.props.location.search)
        this.formBloc.fetchDetail({uuid: queryParams.get('uuid') })

        this.formBloc.pdfChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.LOADING:
                    this.setState({
                        loading: true,
                    })
                    break
                case apiResponse.COMPLETED:
                    const link = result.data.response
                    window.open(link.file_url, "_blank")
                    //window.location.href = link.file_url
                    this.setState({
                        loading: false,
                        success: true
                    })
                    setTimeout(() => {
                        this.setState({
                            success: false,
                        })
                    }, 1000);
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true
                    })
                    setTimeout(function() {
                        this.setState({
                            failed: false,
                        })
                    }, 1000)
                    break
                default:
                    break
            }
        })
    }

    componentWillUnmount() {
        this.formBloc.detailChannel.unsubscribe()
        this.formBloc.pdfChannel.subscribe()
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <Card>
                                <CardBody>
                                    <div className="float-end">
                                        <Button 
                                        color="info"
                                        type="button"
                                        onClick={
                                            () => {
                                                this.handleButtonPrint()
                                            }
                                        }
                                        > 
                                            <i className="uil-print"></i> Print PDF
                                        </Button>
                                    </div>
                                    <CardTitle>Form Indeks Professionalitas</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Preview dan Download
                                    </CardSubtitle>
                                    <hr />
                                    <Row className="mb-1">
                                        <label className="col-md-7 offset-lg-1">
                                            <strong> PENGUKURAN INDEKS PROFESIONALITAS ASN </strong>
                                        </label>
                                        <Col md="3">
                                        </Col>
                                    </Row>
                                    <Row className="mb-1">
                                        <label className="col-md-2 offset-lg-1">
                                            Nama
                                        </label>
                                        <Col md="7">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.ip_employee_name !== "" ? this.state.detail.ip_employee_name : '-'}</>
                                                : <Shimmer><div style={{width: '40%', height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    <Row className="mb-1">
                                        <label className="col-md-2 offset-lg-1">
                                            NIP
                                        </label>
                                        <Col md="7">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.ip_employee_nip !== "" ? this.state.detail.ip_employee_nip : '-'}</>
                                                : <Shimmer><div style={{width: '40%', height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    <Row className="mb-1">
                                        <label className="col-md-2 offset-lg-1">
                                            Jabatan
                                        </label>
                                        <Col md="7">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.ip_employee_current_position_name !== "" ? this.state.detail.ip_employee_current_position_name : '-'}</>
                                                : <Shimmer><div style={{width: '40%', height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    <Row className="mb-1">
                                        <label className="col-md-2 offset-lg-1">
                                            Unit Kerja
                                        </label>
                                        <Col md="7">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.ip_employee_current_work_unit_name !== "" ? this.state.detail.ip_employee_current_work_unit_name : '-'}</>
                                                : <Shimmer><div style={{width: '40%', height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                    <Row>
                                        <div className="col-lg-10 offset-lg-1">
                                            <table className="table table-bordered">
                                                <thead className="text-center">
                                                    <tr>
                                                        <td rowSpan="2">No</td>
                                                        <td rowSpan="2">Dimensi</td>
                                                        <td rowSpan="2">Indikator</td>
                                                        <td colSpan="2">Bobot (%)</td>
                                                        <td rowSpan="2">Jawaban</td>
                                                        <td rowSpan="2">Bobot Skor</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Dimensi</td>
                                                        <td>Indikator</td>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td rowSpan="7">1</td>
                                                        <td rowSpan="7">Kualifikasi</td>
                                                        <td></td>
                                                        <td className="text-center">25</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td className="text-center">
                                                            {
                                                                this.state.detail ?
                                                                    <>{this.state.detail.ip_ip_qualification_score !== "" ? this.state.detail.ip_ip_qualification_score : '-'}</>
                                                                : <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                            }
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>1. S3</td>
                                                        <td></td>
                                                        <td className="text-center">
                                                          { this.state.detail?.ip_qualification_indicator == 1 ? this.state.detail?.ip_ip_qualification_score : '' }
                                                        </td>
                                                        <td className="text-center">
                                                          { this.state.detail?.ip_qualification_indicator == 1 ? 'x' : '' }
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>2. S2</td>
                                                        <td></td>
                                                        <td className="text-center">
                                                          { this.state.detail?.ip_qualification_indicator == 2 ? this.state.detail?.ip_qualification_score : '' }
                                                        </td>
                                                        <td className="text-center">
                                                          { this.state.detail?.ip_qualification_indicator == 2 ? 'x' : '' }
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>3. S1/D4</td>
                                                        <td></td>
                                                        <td className="text-center">
                                                          { this.state.detail?.ip_qualification_indicator == 3 ? this.state.detail?.ip_qualification_score : '' }
                                                        </td>
                                                        <td className="text-center">
                                                          { this.state.detail?.ip_qualification_indicator == 3 ? 'x' : '' }
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>4. D3</td>
                                                        <td></td>
                                                        <td className="text-center">
                                                          { this.state.detail?.ip_qualification_indicator == 4 ? this.state.detail?.ip_qualification_score : '' }
                                                        </td>
                                                        <td className="text-center">
                                                          { this.state.detail?.ip_qualification_indicator == 4 ? 'x' : '' }
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>5. D1/D2/SLTA/sederajat</td>
                                                        <td></td>
                                                        <td className="text-center">
                                                          { this.state.detail?.ip_qualification_indicator == 5 ? this.state.detail?.ip_qualification_score : '' }
                                                        </td>
                                                        <td className="text-center">
                                                          { this.state.detail?.ip_qualification_indicator == 5 ? 'x' : '' }
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>6. Dibawah SLTA</td>
                                                        <td></td>
                                                        <td className="text-center">
                                                          { this.state.detail?.ip_qualification_indicator == 6 ? this.state.detail?.ip_qualification_score : '' }
                                                        </td>
                                                        <td className="text-center">
                                                          { this.state.detail?.ip_qualification_indicator == 6 ? 'x' : '' }
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr className="bg-secondary">
                                                        <td colSpan="7"></td>
                                                    </tr>
                                                    <tr>
                                                        <td rowSpan="13">2</td>
                                                        <td rowSpan="13">Kompetensi</td>
                                                        <td></td>
                                                        <td className="text-center">40</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td className="text-center">
                                                        {
                                                            this.state.detail ?
                                                                <>{this.state.detail.ip_competition_score !== "" ? this.state.detail.ip_competition_score : '-'}</>
                                                            : <Shimmer><div style={{width: '40%', height: 15}}></div></Shimmer>
                                                        }
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>a. Diklat Kepemimpinan</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>&nbsp;&nbsp;1) Sudah</td>
                                                        <td></td>
                                                        <td className="text-center">{ this.state.detail?.ip_training_struktural_score > 0 ? this.state.detail?.ip_training_struktural_score : '' }</td>
                                                        <td className="text-center">{ this.state.detail?.ip_training_struktural_score > 0 ? 'x' : '' }</td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>&nbsp;&nbsp;2) Belum</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td className="text-center">{ this.state.detail?.ip_training_struktural_score < 1 ? 'x' : '' }</td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>b. Diklat Fungsional</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>&nbsp;&nbsp;1) Sudah</td>
                                                        <td></td>
                                                        <td className="text-center">{ this.state.detail?.ip_training_fungsional_score > 0 ? this.state.detail?.ip_training_fungsional_score : '' }</td>
                                                        <td className="text-center">{ this.state.detail?.ip_training_fungsional_score > 0 ? 'x' : '' }</td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>&nbsp;&nbsp;2) Belum</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td className="text-center">{ this.state.detail?.ip_training_fungsional_score < 1 ? 'x' : '' }</td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>c. Diklat Teknis 20 JP</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>&nbsp;&nbsp;1) Sudah</td>
                                                        <td></td>
                                                        <td className="text-center">{ this.state.detail?.ip_training_teknis_score > 0 ? this.state.detail?.ip_training_teknis_score : '' }</td>
                                                        <td className="text-center">{ this.state.detail?.ip_training_teknis_score > 0 ? 'x' : '' }</td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>&nbsp;&nbsp;2) Belum</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td className="text-center">{ this.state.detail?.ip_training_teknis_score < 1 ? 'x' : '' }</td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>d. Seminar/Workshop/sejenis</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>&nbsp;&nbsp;1) Sudah</td>
                                                        <td></td>
                                                        <td className="text-center">{ this.state.detail?.ip_seminar_score > 0 ? this.state.detail?.ip_seminar_score : '' }</td>
                                                        <td className="text-center">{ this.state.detail?.ip_seminar_score > 0 ? 'x' : '' }</td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>&nbsp;&nbsp;2) Belum</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td className="text-center">{ this.state.detail?.ip_seminar_score < 1 ? 'x' : '' }</td>
                                                        <td></td>
                                                    </tr>
                                                    <tr className="bg-secondary">
                                                        <td colSpan="7"></td>
                                                    </tr>
                                                    <tr>
                                                        <td rowSpan="6">3</td>
                                                        <td rowSpan="6">Kinerja</td>
                                                        <td>SKP dan Penilaian Perilaku</td>
                                                        <td className="text-center">30</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td className="text-center">
                                                        {
                                                            this.state.detail ?
                                                                <>{this.state.detail.ip_performance_score !== "" ? this.state.detail.ip_performance_score : '0'}</>
                                                            :
                                                                <Shimmer><div style={{width: '80%', height: 15}}></div></Shimmer>
                                                        }
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>1) 91 - 100</td>
                                                        <td></td>
                                                        <td className="text-center">{ (this.state.detail?.ip_employee_skp_score >= 91 && this.state.detail?.ip_employee_skp_score <= 100) ? this.state.detail?.ip_performance_score : '' }</td>
                                                        <td className="text-center">{ (this.state.detail?.ip_employee_skp_score >= 91 && this.state.detail?.ip_employee_skp_score <= 100) ? 'x' : '' }</td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>2) 76 - 90</td>
                                                        <td></td>
                                                        <td className="text-center">{ (this.state.detail?.ip_employee_skp_score >= 76 && this.state.detail?.ip_employee_skp_score <= 90) ? this.state.detail?.ip_performance_score : '' }</td>
                                                        <td className="text-center">{ (this.state.detail?.ip_employee_skp_score >= 76 && this.state.detail?.ip_employee_skp_score <= 90) ? 'x' : '' }</td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>3) 61 - 75</td>
                                                        <td></td>
                                                        <td className="text-center">{ (this.state.detail?.ip_employee_skp_score >= 61 && this.state.detail?.ip_employee_skp_score <= 75) ? this.state.detail?.ip_performance_score : '' }</td>
                                                        <td className="text-center">{ (this.state.detail?.ip_employee_skp_score >= 61 && this.state.detail?.ip_employee_skp_score <= 75) ? 'x' : '' }</td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>4) 51 - 60</td>
                                                        <td></td>
                                                        <td className="text-center">{ (this.state.detail?.ip_employee_skp_score >= 51 && this.state.detail?.ip_employee_skp_score <= 60) ? this.state.detail?.ip_performance_score : '' }</td>
                                                        <td className="text-center">{ (this.state.detail?.ip_employee_skp_score >= 51 && this.state.detail?.ip_employee_skp_score <= 60) ? 'x' : '' }</td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>5) dibawah 50</td>
                                                        <td></td>
                                                        <td className="text-center">{ (this.state.detail?.ip_employee_skp_score >= 1 && this.state.detail?.ip_employee_skp_score <= 50) ? this.state.detail?.ip_performance_score : '' }</td>
                                                        <td className="text-center">{ (this.state.detail?.ip_employee_skp_score >= 1 && this.state.detail?.ip_employee_skp_score <= 50) ? 'x' : '' }</td>
                                                        <td></td>
                                                    </tr>
                                                    <tr className="bg-secondary">
                                                        <td colSpan="7"></td>
                                                    </tr>
                                                    <tr>
                                                        <td rowSpan="5">4</td>
                                                        <td rowSpan="5">Disiplin</td>
                                                        <td>1) Tidak Pernah Hukuman Disiplin</td>
                                                        <td className="text-center">5</td>
                                                        <td></td>
                                                        <td className="text-center">
                                                        {
                                                            this.state.detail ?
                                                                <>{this.state.detail.ip_discpline_score > 0 ? 'x' : '-'}</>
                                                            :
                                                                <Shimmer><div style={{width: '80%', height: 15}}></div></Shimmer>
                                                        }
                                                        </td>
                                                        <td className="text-center">
                                                        {
                                                            this.state.detail ?
                                                                <>{this.state.detail.ip_discpline_score !== "" ? this.state.detail.ip_discpline_score : '-'}</>
                                                            :
                                                                <Shimmer><div style={{width: '80%', height: 15}}></div></Shimmer>
                                                        }
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>2) Pernah Hukuman Disiplin</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>&nbsp;&nbsp;a. Ringan</td>
                                                        <td></td>
                                                        <td className="text-center">{ this.state.detail?.ip_employee_punishment_level == 1 ? this.state.detail?.ip_discpline_score : '' }</td>
                                                        <td className="text-center">{ this.state.detail?.ip_employee_punishment_level == 1 ? 'x' : '' }</td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>&nbsp;&nbsp;b. Sedang</td>
                                                        <td></td>
                                                        <td className="text-center">{ this.state.detail?.ip_employee_punishment_level == 2 ? this.state.detail?.ip_discpline_score : '' }</td>
                                                        <td className="text-center">{ this.state.detail?.ip_employee_punishment_level == 2 ? 'x' : '' }</td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>&nbsp;&nbsp;c. Berat</td>
                                                        <td></td>
                                                        <td className="text-center">{ this.state.detail?.ip_employee_punishment_level == 3 ? this.state.detail?.ip_discpline_score : '' }</td>
                                                        <td className="text-center">{ this.state.detail?.ip_employee_punishment_level == 3 ? 'x' : '' }</td>
                                                        <td></td>
                                                    </tr>
                                                    <tr className="bg-secondary">
                                                        <td colSpan="7"></td>
                                                    </tr>
                                                    <tr>
                                                        <td colSpan="3">Jumlah</td>
                                                        <td>100</td>
                                                        <td>Nilai IP</td>
                                                        <td></td>
                                                        <td className="text-center">
                                                        {
                                                            this.state.detail ?
                                                                <>{this.state.detail.ip_score !== "" ? this.state.detail.ip_score : '-'}</>
                                                            : <Shimmer><div style={{width: 50, height: 15}}></div></Shimmer>
                                                        }
                                                        </td>
                                                    </tr>
                                                    
                                                </tbody>
                                            </table>
                                        </div>
                                    </Row>

                                    <hr />

                                    <Row>
                                        <Col lg="1"></Col>
                                        <Col lg="5">
                                            <Link to="/kepegawaian/indeks_professionalitas.html?" className="waves-effect">
                                                <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                            </Link>
                                        </Col>
                                    </Row>

                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>

                <ConfirmAlert

                    loadingTitle="Membuat file..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="File akan segera terunduh otomatis"

                    failedTitle="Gagal!"
                    failedInfo="File gagal dibuat, silahkan coba lagi"

                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}
                    response={this.confirmResponse}
                />
            </Fragment>
        )
    }
}

//export default IndexView
export default withRouter(IndexView);